import { useGetProductLinkAuthQuery } from '@/redux/api/client/product';
import ErrorPage from '@/pages/ErrorPage';
import PageLoading from '@/routes/PageLoading';
import { Navigate, useParams } from 'react-router-dom';

const ProductLinkAuthResolver = () => {
  const code = useParams()['code'];
  const isLegacyAspRoute = code?.toLowerCase().endsWith('.asp') ?? false;
  const { data: productLink, isLoading } = useGetProductLinkAuthQuery(code!, {
    skip: !code || isLegacyAspRoute
  });
  const url = productLink ? new URL(productLink) : undefined;
  const possibleRedirectTo = `${window.location.pathname}${window.location.search}`;

  if (isLoading) return <PageLoading />;
  if (url?.pathname) {
    const searchParams = window.location.search;
    const hash = window.location.hash;
    return <Navigate to={`${url.pathname}${searchParams}${hash}`} replace />;
  }

  return <ErrorPage message={'404 Page not found'} possibleRedirectTo={possibleRedirectTo} />;
};

export default ProductLinkAuthResolver;
